import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className, delay = 0, y = 40, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SplitLines = ({ lines, delay = 0, inView = false, className = "" }) => (
  <motion.span
    className="block"
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.13, delayChildren: delay } } }}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, margin: "-40px" } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${className}`}
          variants={{ hidden: { y: "110%" }, show: { y: 0, transition: { duration: 1.1, ease: EASE } } }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow ${className}`}>{children}</p>
);
